<script>
  /**
   * Horizontal stacked bar showing the vote share of each top party,
   * coloured by the project's `--N` palette via `partyColor`.
   */
  let { topParties = [], partyColor } = $props();

  const totalPct = $derived(
    topParties.reduce((s, p) => s + (p.pct || 0), 0) || 100
  );
</script>

<div class="stacked-bar">
  {#each topParties as p, i (p.name + i)}
    <div
      style:width={((p.pct / totalPct) * 100).toFixed(1) + '%'}
      style:background={partyColor(p.name, p.code)}
    ></div>
  {/each}
</div>
